// extracted by mini-css-extract-plugin
export var askAiIcon = "_nf-9";
export var container = "_nf-0";
export var groupSeparator = "_nf-a";
export var highlight = "_nf-4";
export var resultIcon = "_nf-5";
export var resultItem = "_nf-7";
export var resultSubtitle = "_nf-3";
export var resultTitle = "_nf-2";
export var resultsList = "_nf-1";
export var searchGroup = "_nf-6";
export var selected = "_nf-8";